export abstract class RandomGenerator {
    static generateRandomString() : string {
        return (Math.random() + 1).toString(36).substring(7)
    }
}